import { render, staticRenderFns } from "./loginheader.vue?vue&type=template&id=4a9d3cdc&scoped=true&"
import script from "./loginheader.vue?vue&type=script&lang=js&"
export * from "./loginheader.vue?vue&type=script&lang=js&"
import style0 from "./loginheader.vue?vue&type=style&index=0&id=4a9d3cdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d3cdc",
  null
  
)

export default component.exports